var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 69,
    viewBox: "0 0 61 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2711 38.0813H6.32525C3.44003 38.0813 1.11611 40.5398 1.66209 43.3729C5.4527 63.0423 22.509 67.5401 31.2128 67.2053C49.6973 67.2053 57.4271 53.4896 59.7999 43.3499C60.4584 40.5361 58.161 38.0813 55.2711 38.0813Z",
    fill: "#EFEFEF",
    stroke: "#1B1C1F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8863 47.3355L14.3364 46.7911C14.3364 58.3319 25.4054 64.3926 30.9398 66.3886C47.5432 66.933 54.8923 54.6846 57.8863 47.3355Z",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5008 46.7911H5.10815C3.6711 46.7911 2.43264 45.7553 2.15957 44.3444C1.56241 41.2591 3.91797 38.3533 7.06054 38.3533H54.5484C57.691 38.3533 60.0465 41.2591 59.4494 44.3444C59.1763 45.7553 57.9378 46.7911 56.5008 46.7911Z",
    fill: "#FF4135",
    stroke: "#1B1C1F",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8707 38.0813H8.03897C6.71159 38.0813 5.46267 37.2113 5.37083 35.8871C5.24496 34.0721 5.90548 33.1029 6.87725 32.6535C8.79756 31.7655 10.896 30.3292 12.0538 28.5584C13.0161 27.0864 14.6308 26.836 16.1897 27.1074C17.8032 27.3883 19.5216 26.78 20.9413 25.9633C21.3785 25.7119 21.8215 25.5683 22.2549 25.5057C24.0749 25.2429 26.2217 24.7675 27.7936 23.8132C28.6473 23.2949 29.4577 23.2904 30.17 23.5603C31.7507 24.1591 33.5769 24.741 35.2296 24.3868C36.9846 24.0106 38.3644 24.4975 39.3848 25.3013C40.8244 26.4353 42.9613 27.0288 44.723 27.5337C45.7398 27.8251 46.5109 28.5847 47.0739 29.4983C48.0466 31.0763 49.8655 32.1574 51.7192 32.1565C54.5468 32.1552 55.4042 33.9838 55.4369 35.8513C55.4603 37.1887 54.2082 38.0813 52.8707 38.0813Z",
    fill: "#82B253",
    stroke: "#1B1C1F",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1942 32.6621C38.7147 32.6985 41.8561 33.3228 42.258 35.5284",
    stroke: "#1B1C1F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8468 29.1859C27.3673 29.2223 30.5087 29.8466 30.9106 32.0522",
    stroke: "#1B1C1F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9299 35.8902C16.8006 34.6432 19.0571 32.3702 21.1173 33.2543",
    stroke: "#1B1C1F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3475 10.1566L18.8829 13.2573C18.0773 14.2708 18.4626 15.7734 19.6566 16.2741V16.2741C20.6072 16.6727 21.0844 17.7415 20.7466 18.7155L19.1277 23.383",
    stroke: "#1B1C1F",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0313 1L28.4592 4.8969C27.4958 5.94791 27.9101 7.64068 29.25 8.12793L30.0911 8.4338C31.1526 8.81978 31.6841 10.0075 31.2646 11.0562L28.9791 16.7699",
    stroke: "#1B1C1F",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2577 5.06958L41.6855 8.96648C40.7221 10.0175 41.1364 11.7103 42.4763 12.1975L43.3174 12.5034C44.3789 12.8894 44.9104 14.0771 44.4909 15.1257L42.2054 20.8395",
    stroke: "#1B1C1F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.533e6a7d8907a9cfac836a6c6780b2f2.svg";
export { ForwardRef as ReactComponent };